module.exports = __webpack_public_path__ + "img/brands.9ced4f5d.png";